import React from 'react';
import './PointedSeparator.scss';

export const triangleStyle = tab => ['triangle', tab].join(' ');

export const boxStyle = separatorMargin => {
  const style = separatorMargin ? 'box separator-margin' : 'box';
  return style;
};

const PointedSeparator = props => {
  const { tab, separatorMargin } = props;
  return (
    <>
      <div className={boxStyle(separatorMargin)}>
        <div className='line'>
          <div className={triangleStyle(tab)} />
        </div>
      </div>
    </>
  );
};

export default PointedSeparator;
